var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group mt-2" }, [
    _c(
      "label",
      { staticClass: "form-label", attrs: { for: "payment_online" } },
      [_vm._v("\n        Відповідальний\n    ")]
    ),
    _vm._v(" "),
    _vm.draw_items.length > 0
      ? _c(
          "div",
          {},
          [
            _c(
              "v-select",
              {
                staticClass: "imc_reasons",
                attrs: {
                  id: "users_list",
                  reduce: (item) => item.id,
                  label: "name",
                  options: this.draw_items,
                  searchable: true,
                  filterable: true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function (option) {
                        return [
                          _c("div", { staticClass: "d-center" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(option.name) +
                                "\n                    "
                            ),
                            _c("div", { staticClass: "user_dolznost small" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.dolznost) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1329354305
                ),
                model: {
                  value: _vm.active_dep_id,
                  callback: function ($$v) {
                    _vm.active_dep_id = $$v
                  },
                  expression: "active_dep_id",
                },
              },
              [
                _c("template", { slot: "no-options" }, [
                  _vm._v("\n                Оберіть організацію\n            "),
                ]),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }